module.exports = __webpack_public_path__ + "img/bg41.1c3ff5ec.png";